import {useQuery} from "@tanstack/react-query";
import {readDashboardSetting} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

interface Props {
    param: DashboardSettingSearchParamType
}

export const useReadDashboardSetting = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readDashboardSetting", param],
        queryFn: async () => await readDashboardSetting(param),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
